import React from 'react';

type ZIndexProps = {
  children: React.ReactNode;
  index: number;
};

export const ZIndex = ({ children, index }: ZIndexProps) => {
  return <div style={{ zIndex: index }}>{children}</div>;
};
